<template>
  <span class="language_wrap">

    <mobile-sort-filter class="btn-sort-tablet"/>

    <sort-by-other/>

    <div v-if="hebrew_option" class="language-wrap-inner">
      <p class="lang_eng lang_single" 
      :class="{lang_active: isEnglish} "
      @click="setEnglish()"
      >ABC</p>
      <p class="lang_heb lang_single " 
      :class="{lang_active: isHebrew} "
      @click="setHebrew()"
      >אבג</p>
    </div> 
  </span>
</template>

<script>
import MobileSortFilter from  '../../layouts/MobileSortFilter'
import SortByOther from './SortByOther'
import state from "../state.js";
export default {

  data: function() {
    return {
      state,
     // hebrew_mode: false
    };
  },

  computed: {
    hebrew_option() {
      return this.state.getHebrewOption()
    },
    isHebrew(){
      return this.state.data.hebrewMode;
    },
    isEnglish(){
      return this.state.data.englishMode;
    }
  },

  methods: {
    setHebrew() {
      this.state.setHebrewMode();
    },
    setEnglish(){
      this.state.setEnglishMode();
    }    
  },

  created(){
    this.state.getCurrentLang()
  },

  components:{
    SortByOther,
    MobileSortFilter
  }
};
</script>
<style scoped>
.btn-sort-tablet{
  margin-right: 10px;
  display: none;
}
.language-wrap-inner{
  display:flex;
  margin-left:15px;
}
@media screen and (max-width: 1000px){
  .btn-sort-tablet{
    display: block;
  }
}
@media screen and (max-width: 768px){
  .btn-sort-tablet{
    display: none;
  }
}
</style>





// WEBPACK FOOTER //
// resources/js/components/products/components/ProductLanguageOption.vue